import "./Footer.css";

export default function Footer() {


  return (
    <footer>
      <p>Realizado por Leandro João Cruz Salvador<br/>3ºSIS Nº10</p>
      <p>2022/2023</p>
    </footer>
  );
}
